.searchFieldContainer {
  display: flex;
  flex-direction: column;
}

.searchFieldContent {
  display: flex;
  gap: var(--ism-spacing-s);
  align-items: center;
  width: 100%;
}

.searchFieldInputWrapper {
  position: relative;
  display: flex;
  flex-grow: 1;
  align-items: center;
}

.searchIcon {
  position: absolute;
  inset-inline-start: var(--ism-spacing-m);
  top: 50%;
  fill: var(--ism-color-on-surface);
  transform: translateY(-50%);
}

.searchFieldContainer[data-disabled] .searchIcon {
  cursor: not-allowed;
  opacity: 0.5;
}

.clearButton {
  position: absolute;
  inset-inline-end: var(--ism-spacing-s);
  width: 16px;
  height: 16px;
  padding: 0;
  font-size: var(--ism-font-size-body-m);
  line-height: 1;
  color: var(--ism-color-on-surface);
  cursor: pointer;
  background: transparent;
  border: none;
  border-radius: var(--ism-radius-m);
}

.clearButton[data-hovered] {
  background: color-mix(
    in srgb,
    var(--ism-color-on-primary),
    var(--ism-color-primary) 5%
  );
}

.searchFieldContainer[data-disabled] .clearButton {
  color: var(--ism-color-on-surface);
  cursor: not-allowed;
  opacity: 0.5;
}

.searchFieldContainer[data-empty] .clearButton {
  display: none;
}

.cancelButton {
  font-family: var(--ism-typeface-bold);
}
